import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "region-dashboards-addition-filter-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardsYearFilterBlock = _resolveComponent("DashboardsYearFilterBlock")!
  const _component_SelectMultiComponent = _resolveComponent("SelectMultiComponent")!
  const _component_InputBlock = _resolveComponent("InputBlock")!
  const _component_RegionDashboardsExportButtons = _resolveComponent("RegionDashboardsExportButtons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DashboardsYearFilterBlock, {
      class: "region-dashboards-addition-filter-block__item",
      filter: _ctx.filter,
      onChangeFilter: _ctx.changeFilter
    }, null, 8, ["filter", "onChangeFilter"]),
    _createVNode(_component_InputBlock, {
      class: "region-dashboards-addition-filter-block__item region-dashboards-addition-filter-block__item_country",
      title: "Страны",
      mode: "horizontal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SelectMultiComponent, {
          "onUpdate:modelValue": _ctx.updateCountryId,
          options: _ctx.partnerCountryList,
          placeholder: "Выберите",
          classSelect: "multiselect--rectangular visible-clear",
          valueProp: "id",
          trackBy: "name",
          label: "name",
          canClear: ""
        }, null, 8, ["onUpdate:modelValue", "options"])
      ]),
      _: 1
    }),
    _createVNode(_component_RegionDashboardsExportButtons, {
      class: "region-dashboards-addition-filter-block__item region-dashboards-addition-filter-block__export",
      filter: _ctx.filter
    }, null, 8, ["filter"])
  ]))
}